import axios, { type RawAxiosRequestHeaders } from 'axios';
import drupalParams from './drupalParams';

const headers: Partial<RawAxiosRequestHeaders> = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

const createClient = () => {
  const requestUrl = `/${ drupalParams.locale }/cacom-productdb`;
  const client = axios.create({
    baseURL: requestUrl,
    headers: headers,
    withCredentials: true,
  });

  return client;
};

export const httpClient = createClient();
